import { useState } from 'react'

const useDebugConsole = () => {
  const debug = process.env.REACT_APP_DEBUG === 'true' ? true : false
  const debugP2 = process.env.REACT_APP_DEBUG_P2 === 'true' ? true : false

  const modes = `${debug ? 'P1' : ''} ${debugP2 ? 'P2' : ''}`

  const [msg, setMsg] = useState(
    debug || debugP2 ? `DEBUG MODE ${modes}` : null
  )

  return {
    debug,
    msg,
  }
}

export default useDebugConsole
